import * as React from 'react';
import { Navigate } from 'react-router-dom';

import Container from '@Components/layout/Container';
import Layout, { LayoutBackgrounds } from '@Components/layout/Layout';
import LoadingSpinner from '@Components/LoadingSpinner';
import { MetaWrapper } from '@Components/Meta';
import { RouteConfig } from '@Config/routes';
import { useLoadAdForDisplayQuery } from '@Graphql/graphqlTypes.generated';
import { useRouteParams } from '@Hooks/useRouteParams';
import AdPage from '@Routes/ads/AdPage/AdPage';
import { buildAdvertMeta } from '@Utils/meta';

const AdPageContainer: React.FunctionComponent<{}> = () => {
  const { slug } = useRouteParams(RouteConfig.Advert);

  const { data, loading, error } = useLoadAdForDisplayQuery({
    variables: { slug },
    fetchPolicy: 'network-only',
  });

  if (error || data?.advertBySlug === null) {
    return <Navigate to={RouteConfig.NotFound.buildLink()} replace />;
  }

  return (
    <Layout background={LayoutBackgrounds.grayBackground}>
      <Container>
        {loading || !data || !data.advertBySlug ? (
          <LoadingSpinner />
        ) : (
          <MetaWrapper meta={buildAdvertMeta(data.advertBySlug)}>
            <AdPage advert={data.advertBySlug} />
          </MetaWrapper>
        )}
      </Container>
    </Layout>
  );
};

export default AdPageContainer;
